import { render, staticRenderFns } from "./PageTwo.vue?vue&type=template&id=dbca180c&scoped=true&"
import script from "./PageTwo.vue?vue&type=script&lang=js&"
export * from "./PageTwo.vue?vue&type=script&lang=js&"
import style0 from "./PageTwo.vue?vue&type=style&index=0&id=dbca180c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbca180c",
  null
  
)

export default component.exports